import { useOktaAuth } from '@okta/okta-react';
import { mapPlaylistFromVideoSearch } from 'yankees-react-utils';
import { useContext } from 'react';
import { Video } from './data';
import { store } from '../store';

const usePitchVideoFn = () => {
    const { authState: { accessToken } } = useOktaAuth();
    const { state: { user } } = useContext(store);

    if (window.$IsDugoutApp) {
        return null;
    }
    return async (gameId, eventSeq, pitchSeq) => {
        if (!(gameId && eventSeq)) return null;
        const resp = await Video.search(accessToken, { gameId, eventSeq, pitchSeq });
        return mapPlaylistFromVideoSearch(resp, user.Roles.map((r) => r.RoleName));
    };
};

export default usePitchVideoFn;
